import { UserControllerService } from 'shared/api/generatedApi/services/UserControllerService';
import { UserRequestDto, UpdateUserStatusRequestDto, UserResponseDto } from 'shared/api';

export const usersApi = {
  getUsers: (email?: string, status?: UserResponseDto.status, company?: string) => UserControllerService.findUsers(email, status, company),
  getUserById: (id: number) => UserControllerService.findUserById(id),
  createUser: (data: UserRequestDto) => UserControllerService.createUser(data),
  updateUser: (id: number, data: UserRequestDto) => UserControllerService.updateUser(id, data),
  updateUserStatus: (id: number, status: UpdateUserStatusRequestDto.status) => UserControllerService.updateUserStatus(id, { status }),
  deleteUser: (id: number) => UserControllerService.deleteUser(id),
};
